module.exports = __webpack_public_path__ + "static/media/university-scholarships.e69eec67.jpg";